// src/App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import ArticleDetailPage from './pages/ArticleDetailPage';
import AboutPage from './pages/AboutPage';
import WritePage from './pages/WritePage';
import Header from './components/Header';
import ConfigNotice from './components/ConfigNotice';
import { testSupabaseConnection, testAuth } from './utils/testSupabase';
import './styles/MediumHome.css';

// 受保护的路由组件
function PrivateRoute({ children }: { children: React.ReactElement }) {
    const token = localStorage.getItem('token');
    const location = useLocation();
    if (!token) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }
    return children;
}

const App: React.FC = () => {
    useEffect(() => {
        // 测试 Supabase 连接
        const runTests = async () => {
            await testSupabaseConnection();
            await testAuth();
        };

        runTests();
    }, []);

    return (
        <Router>
            <Header />
            <ConfigNotice />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/" element={
                    <PrivateRoute>
                        <HomePage />
                    </PrivateRoute>
                } />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/article/:id" element={<ArticleDetailPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/write" element={<WritePage />} />
            </Routes>
        </Router>
    );
};

export default App;